// src/components/PropertyPanel/CommonProperties/PaddingControl.js
import React, { useState, useEffect } from 'react';
import { usePropertyPanel } from '../PropertyPanelContext';
import { extractValueAndUnit } from '../utils/styleUtils';
import { useSelector } from 'react-redux';
import { selectSelectedComponent } from '../../../redux/editorSlice';
import { useDispatch } from 'react-redux';
import { updateComponent } from '../../../redux/editorSlice';

const PaddingControl = () => {
  const selectedComponent = useSelector(selectSelectedComponent);
  const dispatch = useDispatch();
  const { devicePropertyTab = 'pc' } = usePropertyPanel() || {}; // 디바이스 탭 정보 가져오기
  const style = selectedComponent?.style || {};
  
  // 패딩 입력값 관리를 위한 로컬 상태
  const [paddingInputs, setPaddingInputs] = useState({
    top: '',
    right: '',
    bottom: '',
    left: ''
  });
  
  // 스타일에서 패딩 값 추출
  useEffect(() => {
    if (style) {
      const { value: topValue, unit: topUnit } = extractValueAndUnit(style.paddingTop || '0px');
      const { value: rightValue, unit: rightUnit } = extractValueAndUnit(style.paddingRight || '0px');
      const { value: bottomValue, unit: bottomUnit } = extractValueAndUnit(style.paddingBottom || '0px');
      const { value: leftValue, unit: leftUnit } = extractValueAndUnit(style.paddingLeft || '0px');
      
      setPaddingInputs({
        top: `${topValue}${topUnit}`,
        right: `${rightValue}${rightUnit}`,
        bottom: `${bottomValue}${bottomUnit}`,
        left: `${leftValue}${leftUnit}`
      });
    }
  }, [style, selectedComponent?.id]);
  
  // 패딩 값 변경 핸들러
  const handlePaddingValueChange = (direction, value) => {
    // 임시로 로컬 상태 업데이트
    setPaddingInputs(prev => ({
      ...prev,
      [direction]: value
    }));
  };
  
  // 패딩 값 적용 핸들러 (포커스를 잃을 때)
  const handlePaddingValueBlur = (direction) => {
    if (!selectedComponent) return;
    
    const value = paddingInputs[direction];
    const { value: numValue, unit } = extractValueAndUnit(value);
    
    // 스타일 속성명 매핑
    const styleProperty = {
      top: 'paddingTop',
      right: 'paddingRight',
      bottom: 'paddingBottom',
      left: 'paddingLeft'
    }[direction];
    
    // Redux 액션 직접 디스패치로 변경
    const existingStyle = JSON.parse(JSON.stringify(selectedComponent.style || {}));
    
    // 최상위 스타일 업데이트 (항상 적용)
    existingStyle[styleProperty] = `${numValue}${unit}`;
    
    // 디바이스별 스타일도 업데이트
    if (devicePropertyTab) {
      if (!existingStyle.deviceProperty) {
        existingStyle.deviceProperty = { pc: {}, mobile: {} };
        
        // 기존 스타일 복사
        Object.keys(existingStyle).forEach(key => {
          if (key !== 'deviceProperty') {
            existingStyle.deviceProperty.pc[key] = existingStyle[key];
            existingStyle.deviceProperty.mobile[key] = existingStyle[key];
          }
        });
      }
      
      if (!existingStyle.deviceProperty[devicePropertyTab]) {
        existingStyle.deviceProperty[devicePropertyTab] = {};
      }
      
      existingStyle.deviceProperty[devicePropertyTab][styleProperty] = `${numValue}${unit}`;
    }
    
    // 스타일 업데이트 액션 디스패치
    dispatch(updateComponent({
      id: selectedComponent.id,
      changes: {
        style: existingStyle
      }
    }));
  };
  
  return (
    <div className="property-group">
      <div className="property-group-title">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2" />
          <path d="M7 7H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <path d="M7 12H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <path d="M7 17H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
        여백 설정
      </div>
      <div className="padding-controls">
        <div className="padding-control">
          <label style={{ minWidth: '30%' }}>상단 여백</label>
          <input 
            type="text" 
            value={paddingInputs.top} 
            onChange={(e) => handlePaddingValueChange('top', e.target.value)}
            onBlur={() => handlePaddingValueBlur('top')}
          />
        </div>
        <div className="padding-control">
          <label style={{ minWidth: '30%' }}>우측 여백</label>
          <input 
            type="text" 
            value={paddingInputs.right} 
            onChange={(e) => handlePaddingValueChange('right', e.target.value)}
            onBlur={() => handlePaddingValueBlur('right')}
          />
        </div>
        <div className="padding-control">
          <label style={{ minWidth: '30%' }}>하단 여백</label>
          <input 
            type="text" 
            value={paddingInputs.bottom} 
            onChange={(e) => handlePaddingValueChange('bottom', e.target.value)}
            onBlur={() => handlePaddingValueBlur('bottom')}
          />
        </div>
        <div className="padding-control">
          <label style={{ minWidth: '30%' }}>좌측 여백</label>
          <input 
            type="text" 
            value={paddingInputs.left} 
            onChange={(e) => handlePaddingValueChange('left', e.target.value)}
            onBlur={() => handlePaddingValueBlur('left')}
          />
        </div>
      </div>
    </div>
  );
};

export default PaddingControl;